import { LayoutDashboard, Users, Layers, Award, Receipt, PlugZap, ShoppingBasket, Sparkles, BadgePercent, Store, Boxes, Send, FileBarChart, ShieldCheck, Network, Newspaper, CreditCard, LifeBuoy, BookOpen, KeyRound, SlidersHorizontal, FileText } from "lucide-react";

const ICONS = { LayoutDashboard, Users, Layers, Award, Receipt, PlugZap, ShoppingBasket, Sparkles, BadgePercent, Store, Boxes, Send, FileBarChart, ShieldCheck, Network, Newspaper, CreditCard, LifeBuoy, BookOpen, KeyRound, SlidersHorizontal };

export const iconFor = (name) => ICONS[name] || FileText;

export const MANUAL_ROUTE_IDS = [
  ["/manuale", "manuale"], ["/clienti", "clienti"], ["/kpi-carte", "kpi-carte"], ["/segmenti", "segmenti"], ["/fedelta", "fedelta"],
  ["/transazioni", "transazioni"], ["/punti-vendita", "punti-vendita"], ["/carta-fedelta", "carta-fedelta"], ["/cluster", "cluster"],
  ["/comunicazioni", "comunicazioni"], ["/paniere", "paniere"], ["/promozioni", "promozioni"], ["/volantini-promo", "volantini-promo"],
  ["/analisi-ia", "analisi-ia"], ["/report", "report"], ["/impostazioni-api", "impostazioni"], ["/superadmin", "superadmin"],
  ["/circuiti", "circuiti"], ["/assistenza", "assistenza"],
];

export const manualIdFor = (path) => (MANUAL_ROUTE_IDS.find(([p]) => path.startsWith(p)) || [null, "dashboard"])[1];

export const fmtDate = (iso) => new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
